import React, { useState,useRef,useCallback, useEffect, useContext } from 'react'
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import { useFetch } from '../../api/FetchApiData';
import { MediaUrl } from '../../utils/media/Media';
import { ButtonLoader } from '../../utils/Loaders/ButtonLoader';
import { AppContext, UserContext } from '../../../AppContextProvider';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import Popup from 'reactjs-popup';
import { useInfiniteScroll } from '../../utils/InfiniteScroll';
import { TicketView } from '../sales/Sale';
import DeviceRegistration from '../device/Device';
import { useTranslation } from 'react-i18next';
if (isMobile)
    import('./deliver_mob.css').then(() => {});
else
    import('./deliver.css').then(() => {});


export function Fret({editable=true,fret={depository:{id:null},id:null,exp_date:"",arr_date:"", status:'incomplet', price:{price:0,unit:'m²'}}, is_new=true, close=()=>{}, setDeliver=()=>{}})
{
    console.log(fret);
    const [edit,setEdit] = useState(is_new);
    const [fretData, setFretData] = useState({...fret,address_id:fret.depository?fret.depository.id:null});
    const [addresses,setAddresses] = useState([]);
    const fetchData = useFetch();
    const [notif,setNotif] = useState({text:'',color:'black'});
    const [selAddress,SetSelAddress] = useState(null);
    const {t} = useTranslation();


    const AddressLabel = (address)=>{
        return(
          <div>
            <label style={{fontStyle:'bold'}}>{address.label}</label>
            <label style={{display:'block',fontSize:'small'}}>{address.display_name} {address.ville}</label>
          </div>
        );
    }

    const onFredSumitted = ()=>{
      const _fret_ = {...fretData,price:JSON.stringify(fretData.price)};
      if(!!fretData.expDate && !!fretData.arrDate && !!fretData.price)
      {
        console.log(_fret_);
        fetchData.PostData(_fret_,'user/deliver/frets/').then((result)=>{
          console.log(result);
          if(result.result)
          {
              setDeliver(result.deliver);
              setNotif({text:'Ajouter avec Succés',color:'green'});
              setTimeout(()=>{setNotif({text:'',color:'black'});close();},5000)
          }
          else{
              setNotif({text:'Erreur Serveur',color:'red'});
              setTimeout(()=>{setNotif({text:'',color:'black'});},5000)
          }
        })
      }
    }

    useEffect(()=>{
      fetchData.GetData('user/addresses/').then((result)=>{
          if(result.results)
          {
              let arr = [];
              result.addresses.forEach(element => {
                const v = {
                    label:AddressLabel(element),
                    value:element,
                    tag:element,
                };
                arr.push(v);
              });
              setAddresses(arr);
          }
      }).catch(()=>{})

    },[])

    useEffect(()=>{
      setFretData({...fret,address_id:fret.depository?fret.depository.id:null,})
    },[fret])


    useEffect(()=>{
      addresses.forEach((ad)=>{
        if(ad.value.id===fretData.address_id)
          {SetSelAddress(ad);return;}
      })
    
    },[addresses]);

    const onAddressSelected = (value)=>{
        if(!!value.value && !!value.value.id)
        {
          setFretData({...fretData,address_id:value.value.id});
          SetSelAddress(value);
        }
    }

    const TranslateStatus=(status)=>{
      if(status==='INCOMPLET')
        return t('livreur.incomplet')
      else
        return t('livreur.complet')
    }

    let status_color = 'black';
    if(!!fret.status && fret.status==='incomplet')
      status_color = 'green';
    else if(fret.status==='complet')
      status_color = 'orange';

      return(
        <div className='fret' style={{width:'100%',borderBottom:'1px solid lightgray'}}>
          { !is_new &&
            <div className='fret-header' style={{width:'100%',marginTop:'5px'}}>
              { editable && <input onClick={e=>{setEdit(!edit);}} style={{display:'inline-block',height:'40px',width:'50px',border:'1px solid lightgray',verticalAlign:'middle',borderRadius:'5px'}} type='button' value={'+'}/>}
              <div style={{width:'80%',display:'inline-block',verticalAlign:'middle',paddingBottom:'5px'}}>
                <div style={{margin:'auto'}}>
                    <label dir='rtl' style={{display:'inline-block',marginRight:'30px',fontSize:'small'}}>{t('produit.reference')} : {fret.id}</label>
                    <label dir='rtl' style={{display:'inline-block',color:status_color,margin:'2px',fontSize:'small'}}>{t('sales.status')} : {TranslateStatus(fret.status)}</label><br/>
                    <label style={{display:'inline-block',fontSize:'small',marginRight:'10px'}}>{t('livreur.date-exp')} : {fret.exp_date}</label>
                    <label style={{display:'inline-block',fontSize:'small'}}>{t('livreur.date-arr')} : {fret.arr_date.date}</label>
                </div>
                <div>
                  <label style={{display:'inline-block',fontSize:'x-small',color:'gray',margin:'2px',marginRight:'20px'}}>Dépôt : {!!(fret.depository)?fret.depository.label:'Inconnue'} {!!fret.depository?fret.depository.display_name:''}</label>
                </div>
              </div>
            </div>
          }
          { editable && edit &&
              <div style={{margin:'auto',marginTop:'5px'}}>
                  {(notif.text!=='') && <h4 style={{color:notif.color}}>{notif.text}</h4>}
                  <div className='fret-div-input'>
                      <label className='label-fret-input'>{t("livreur.depot")}</label>
                      <div style={{width:'60%',display:'inline-block',textAlign:'center'}}>
                        <Select value={selAddress} options={addresses} onInputChange={(value,action)=>{onAddressSelected(value)}} onChange={(value,action)=>{onAddressSelected(value)}} />
                      </div>
                  </div>
                  <div className='fret-div-input'>
                      <label className='label-fret-input'>{t("livreur.expedition")}</label>
                      <input value={fretData.exp_date} onChange={(e)=>{setFretData({...fretData,exp_ate:e.target.value})}} className='input-deliver-input' type='date' style={{width:'60%'}} />
                  </div>
                  <div className='fret-div-input'>
                      <label className='label-fret-input'>{t("livreur.periodique")}</label>
                      <input checked={fretData.is_periodic} onChange={(e)=>{setFretData({...fretData,is_periodic:e.target.checked})}} className='input-deliver-input' type='checkbox' style={{width:'20px'}} />
                  </div>
                  <div className='fret-div-input'>
                      <label className='label-fret-input'>{t("livreur.periode")}</label>
                      <input value={fretData.periodicity} onChange={(e)=>{setFretData({...fretData,periodicity:e.target.value})}} className='input-deliver-input' type='number' style={{width:'40%'}} />
                  </div>
                  <div className='fret-div-input'>
                      <label className='label-fret-input'>{t("livreur.no-livraison")}</label>
                      <input value={fretData.no_deliver} onChange={(e)=>{setFretData({...fretData,no_deliver:e.target.checked})}} className='input-deliver-input' type='checkbox' style={{width:'20px'}} />
                  </div>
                  <div className='fret-div-input' style={{}}>
                      <label className='label-fret-input'>{t("livreur.arrivee")}</label>
                      <input value={fretData.arr_date} onChange={(e)=>{setFretData({...fretData,arr_date:e.target.value})}}  className='input-deliver-input' type='date' style={{width:'40%',display:'inline-block',verticalAlign:'middle'}} />
                      <span style={{display:'inline-block',verticalAlign:'middle'}}></span>
                      <input style={{display:'inline-block',margin:'-3px 5px 0px 5px',height:'25px',width:'8%',textAlign:'center'}} defaultValue={3} type='number' onChange={(e)=>{setFretData({...fretData,delta:e.target.value})}} />
                      <span className='span-fret-input' style={{color:'gray',fontSize:'small'}}>(+/- {t('livreur.jours')})</span>
                  </div>
                  <div className='fret-div-input'>
                      <label className='label-fret-input'>{t('filters.prix')}</label>
                      <input value={fretData.price.price} onChange={(e)=>{setFretData({...fretData,price:{...fretData.price,price:e.target.value}})}}  className='input-deliver-input' type='number' style={{width:'45%'}}/>
                      <select className='fret-input-unit' value={fretData.price.unit} onChange={e=>{setFretData({...fretData,price:{...fretData.price,unit:e.target.value}})}} style={{}}>
                          <option>m²</option>
                          <option>Kg</option>
                        </select>
                  </div>
                  <div className='fret-div-input'>
                      <label className='label-fret-input'>{t('sales.status')} :</label>
                      <select value={fretData.status} onChange={(e)=>{setFretData({...fretData,status:e.target.value})}}  className='input-deliver-input' style={{width:'60%'}}>
                        <option value={"COMPLET"}>{t('livreur.complet')}</option>
                        <option value={"INCOMPLET"}>{t('livreur.incomplet')}</option>
                      </select>
                  </div>
                  <div className='' style={{textAlign:'center',margin:'10px auto'}}>
                    <input onClick={e=>{onFredSumitted()}} style={{marginRight:'10px',border:'none',borderRadius:'5px',height:'40px',backgroundColor:'lightblue',width:'30%'}} type='button' value={t('user-info.enregistrer')}/>
                    {(fretData.id===null || fretData.id===undefined) && <input onClick={e=>{close()}} style={{border:'none',borderRadius:'5px',height:'40px',backgroundColor:'#FFCBCC',width:'30%'}} type='button' value={'Annuler'}/>}
                  </div>
              </div>
          }
        </div>
        )
}

export function DeliverOrders({deliver_id})
{
    const [page,setPage] = useState({CurrentPage:1,MaxPage:1});
    const [hasMore,setHasMore] = useState(true);
    const [colis,setColis] = useState([]);
    const {t} = useTranslation();
    const fetchData = useFetch();
    let _margin = '100px auto auto auto';
    let _with = '60%';
    let _height = ''
    if(isMobile)
    {
        _margin = '80px 0px auto 0px';
        _with = '95%';
    }

    useEffect(()=>{
        setPage(({CurrentPage:1,MaxPage:1}));
        setHasMore(true);
    },[deliver_id]);

    const FetchOrders = useCallback(async ()=>{    
        if(!hasMore || deliver_id===undefined)
            return;
        if(page.CurrentPage<=page.MaxPage)
        {
            fetchData.GetData(`delivers/colis/${deliver_id}/1/${page.CurrentPage}/`).then((result)=>{
                if(result.result)
                {
                    if(page.CurrentPage>result.maxpage)
                        setHasMore(false);
                    else
                    {setColis([...colis,...result.items]);setPage({...page,CurrentPage:page.CurrentPage+1,MaxPage:result.maxpage});}
                }
            })
        }
    },[page.CurrentPage,hasMore]);

    const LoadMoreOrdersRef_ = useInfiniteScroll(FetchOrders,hasMore);

    let style_sheet = {width:"100%",maxHeight:'50vh',overflowX:'hidden',margin:'auto',overflowY:'auto',backgroundColor:'white',border:'1px solid lightgray',borderRadius:'5px'};
    let ticket_sheet = {width:'15%',display:'inline-block',marginLeft:'5px',verticalAlign:'middle'};
    let info_ticket_sheet = {width:'55%',display:'inline-block',verticalAlign:'middle',textAlign:'center'};
    if(isMobile)
    {
      style_sheet = {...style_sheet,width:'100%',maxHeight:'70vh'};
      ticket_sheet = {...ticket_sheet,width:'25%'};
      info_ticket_sheet = {...info_ticket_sheet,fontSize:'x-small',width:'53%',textAlign:'center'};
    }


    return(
      <div style={style_sheet}>
          {colis.map((colis,index)=>{return(
              <div key={index} style={{borderBottom:'1px solid lightgray',fontSize:'small',width:'100%',padding:'5px 10px 5px 10px',textAlign:'left'}}>
                  <img src={MediaUrl(colis.image)} style={{width:'40px',height:'50px',objectFit:'cover',borderRadius:'5px',verticalAlign:'middle',margin:'0px'}} />
                  <div style={info_ticket_sheet}>
                      <h4 style={{marginBottom:'5px'}}>{colis.title}</h4>
                      <span dir='rtl' style={{color:'gray'}}>{t('produit.reference')+' : '} {colis.order_number}</span><br/>
                      <span dir='rtl' style={{color:'gray'}}>{t('navigation.client')+' : '} {colis.client.label_name}</span><br/>
                      <span dir='rtl' style={{color:'gray'}}>{t('authentication.telephone')+' : '} {colis.client.phone}</span><br/>
                      <span dir='rtl' style={{marginLeft:'10px',color:'gray'}}>{t('user-info.addresse')+' : '} {colis.destination_address}</span><br/>
                      <span dir='rtl' style={{color:'gray',display:'block'}}>{t('sales.status')+' : '} {colis.status}</span>
                  </div>
                  <div style={ticket_sheet}>
                      <TicketView order={{order_number:colis.order_number,
                          customer:{label:colis.client.label_name, phone:colis.client.phone,
                          data:colis.date,
                          address:colis.destination_address
                          }}} qr_size={70} data_ticket={colis.package} title={'Ticket de livraison'} enable_pop_up={true} enable_download={false} show_info={false} />
                  </div>
              </div>
          )})}
          <div ref={LoadMoreOrdersRef_} style={{height:'20px'}}/>     
      </div>);
}

function Deliver({id}) {
    const [deliver,setDeliver] = useState({title:'',phone:"",
        description:"",
        logo :null,
        identite:null,
        rib:null,
        email:'',
        owned:false,
        frets:[],
        id:null
    });
    const {t}=useTranslation();
    const [loading,setLoading] = useState({loading:false,text:t('user-info.enregistrer')});
    const [UserState,setUserState] = useContext(UserContext);
    const [users,setUSers] = useState([]);
    const [selectUser, setSelectedUser] = useState(null);
    const [AppState,setAppState] = useContext(AppContext);

    const navigator = useNavigate();
    const fetchData = useFetch();

    const SaveDeliver = ()=>
    {
      let formData = new FormData();
      let deliver_ = {title:deliver.title,phone:deliver.phone,description:deliver.description,email:deliver.email};
      const logo = deliver.logo;
      if(logo instanceof Blob)
        formData.append('logo',logo,logo.name);
      if( deliver.rib instanceof Blob)
        formData.append('rib',deliver.rib,deliver.rib.name);
      if(deliver.identity instanceof Blob)
        formData.append('identity',deliver.identity,deliver.identity.name);
      if(!!deliver.id)
      {
          deliver_ = {...deliver_,id:deliver.id};
          formData.append('data',JSON.stringify(deliver_));
          fetchData.PutFormData(formData,'deliver/add/').then((result)=>{
              if(result.result)
              {
                  setLoading({loading:false,text:'Données enregistrées'});
                  setTimeout(()=>{setLoading({loading:false,text:'Enregister'});},5000);
              }
              else
              {
                setLoading({loading:false,text:'Erreur serveur'});
                setTimeout(()=>{setLoading({loading:false,text:'Enregister'});},5000);
              }
          })
      }
      else
      {
          formData.append('data',JSON.stringify(deliver_));
          fetchData.PostFormData(formData,'deliver/add/').then((result)=>{
            if(result.result)
              {
                  setLoading({loading:false,text:'Données enregistrées'});
                  setTimeout(()=>{setLoading({loading:false,text:'Enregister'});},5000);
              }
              else
              {
                setLoading({loading:false,text:'Erreur serveur'});
                setTimeout(()=>{setLoading({loading:false,text:'Enregister'});},5000);
              }
            });
      } 
    }

    const RemoveImageFile = (image)=>{
      if(image instanceof Blob)
      {
          deliver.logo.pop(image);setDeliver({...deliver});
      }
      else{
          fetchData.DeleteData(image,'image/').then((result)=>{
              if(result.result)
              {deliver.logo = null;setDeliver({...deliver});}
          })
      }
    }
  
    const RemoveDocumentFile = (document,is_identite)=>{
      if(document instanceof Blob)
      {
        if(is_identite)
        {deliver.identity.pop(document);setDeliver({...deliver});}
        else
          {deliver.rib.pop(document);setDeliver({...deliver});}
      }
      else{
          fetchData.DeleteData(document,'document/').then((result)=>{
              if(result.result)
              {
                if(is_identite)
                {deliver.identity = null;setDeliver({...deliver});}
                else
                {deliver.rib = null;setDeliver({...deliver});}
              }
          })
      }
    }
  
    const Identite = ()=>{
      if(isMobile)
      {
        if(!!deliver.identity)
        {
          let label = !!deliver.identity.title ? deliver.identity.title : deliver.identity.name;
          return(
          <div style={{minHeight:'22px',padding:'3px',width:'50%',backgroundColor:'whitesmoke',borderRadius:'5px',margin:'auto'}}>
            <label style={{display:'inline-block',paddingTop:'3px'}}>{label}</label>
            <span onClick={e=>{RemoveDocumentFile(deliver.identity,true)}} style={{float:'right',backgroundColor:'black',color:'white',padding:'5px',fontSize:'x-small',borderRadius:'3px'}}>X</span>      
          </div>);
        }
        else
        {
          return <input accept="application/pdf" disabled={deliver.owned} style={{border:'none'}} onChange={e=>{setDeliver({...deliver,identity:e.target.files[0]});}} className='partner-input' type='file' multiple={false} />;
        }
      }
      else
      {
        if(!!deliver.identity)
        {
          let label = !!deliver.identity.title ? deliver.identity.title : deliver.identity.name;
          return(
          <div style={{position:'relative',minHeight:'25px',backgroundColor:'whitesmoke',borderRadius:'5px',width:'70%'}}>
            <label style={{display:'inline-block',width:'100%',paddingTop:'10px',paddingBottom:'10px'}}>{label}</label>
            <span onClick={e=>{RemoveDocumentFile(deliver.identity,true)}} style={{position:'absolute',backgroundColor:'black',color:'white',padding:'5px',fontSize:'x-small',borderRadius:'3px',top:'7px',right:'5px'}}>X</span>
          </div>);
        }
        else
        {return <input accept="application/pdf" disabled={deliver.owned} style={{border:'none'}} onChange={e=>{setDeliver({...deliver,identity:e.target.files[0]});}} className='partner-input' type='file' multiple={false} />}
      }
    }
  
    const Rib = ()=>{
      if(isMobile)
      {
        if(!!deliver.rib)
        {
          let label = !!deliver.rib.title ? deliver.rib.title : deliver.rib.name;
          return(
          <div style={{minHeight:'22px',padding:'3px',width:'50%',backgroundColor:'whitesmoke',borderRadius:'5px',margin:'auto'}}>
            <label style={{display:'inline-block',paddingTop:'3px'}}>{label}</label>
            <span onClick={e=>{RemoveDocumentFile(deliver.rib,false)}} style={{float:'right',backgroundColor:'black',color:'white',padding:'5px',fontSize:'x-small',borderRadius:'3px'}}>X</span>      
          </div>);
        }
        else
        {
          return <input accept="application/pdf" disabled={deliver.owned} style={{border:'none'}} onChange={e=>{setDeliver({...deliver,rib:e.target.files[0]});}} className='partner-input' type='file' multiple={false} />;
        }
      }
      else
      {
        if(!!deliver.rib)
        {
          let label = !!deliver.rib.title ? deliver.rib.title : deliver.rib.name;
          return(
          <div className='patner-input' style={{width:'70%',minHeight:'25px',backgroundColor:'whitesmoke',borderRadius:'5px',position:'relative'}}>
            <label style={{display:'inline-block',width:'100%',paddingTop:'10px',paddingBottom:'10px'}}>{label}</label>
            <span onClick={e=>{RemoveDocumentFile(deliver.rib,false)}} style={{position:'absolute',backgroundColor:'black',color:'white',padding:'5px',fontSize:'x-small',borderRadius:'3px',top:'7px',right:'5px'}}>X</span>
          </div>);
        }
        else
        {return <input accept="application/pdf" disabled={deliver.owned} style={{border:'none'}} onChange={e=>{setDeliver({...deliver,rib:e.target.files[0]});}} className='partner-input' type='file' multiple={false} />}
      }
    }
  
    const Logo = ()=>{
      let logo_src = '/images/icons/delivry/delivry.png';
      try{logo_src = URL.createObjectURL(deliver.logo);}
      catch{
        try{logo_src = MediaUrl(deliver.logo.image);}
        catch{logo_src = '/images/icons/delivry/delivry.png';}
      }
      if(isMobile)
      {
        if(!!deliver.logo)
        {return(
          <div style={{margin:'auto'}}>
            <img src={logo_src} style={{width:'80px',margin:'auto',borderRadius:'40px'}} />
            <span onClick={e=>{RemoveImageFile(deliver.logo)}} style={{position:'absolute',backgroundColor:'black',color:'white',padding:'5px',fontSize:'x-small',borderRadius:'3px'}}>X</span>      
          </div>);
        }
        else
        {
          return <input disabled={deliver.owned} style={{border:'none'}} accept="image/png,image/jpeg,image/jpg" className='partner-input' type='file' multiple={false} onChange={e=>{setDeliver({...deliver,logo:e.target.files[0]});}} />
        }
      }
      else
      {
        if(!!deliver.logo)
        {
          return(
          <div style={{margin:'auto'}}>
            <img src={logo_src} style={{width:'100px',margin:'auto',borderRadius:'50px'}} />
            <span onClick={e=>{RemoveImageFile(deliver.logo)}} style={{position:'absolute',backgroundColor:'black',color:'white',padding:'5px',fontSize:'x-small',borderRadius:'3px'}}>X</span>
          </div>);
        }
        else
        {return <input disabled={deliver.owned} style={{border:'none'}} accept="image/png,image/jpeg,image/jpg" className='partner-input' type='file' multiple={false} onChange={e=>{setDeliver({...deliver,logo:e.target.files[0]});}} />}
      }
    }

    useEffect(()=>{
        const opt = users.find(us=>us.value===deliver.email);
        setSelectedUser(opt);
    },[deliver.email])

    useEffect(()=>{
      if(!UserState.is_staff && !UserState.is_deliver)
          navigator('/');
      if(!(id==='add' || id===undefined || id===null))
      {
          fetchData.GetData('deliver/'+id+'/').then((result)=>{
              if(result.result)
              {
                const owner = result.deliver.owner;
                setDeliver({...result.deliver});
                if(result.deliver.owned)
                {
                    UsersOptions([owner]);
                    setSelectedUser({value:owner.email,tag:owner, label:
                    <div>
                        <h4 style={{margin:'0px'}}>{owner.labelname}</h4>
                        <div style={{marginBottom:'10px',color:'gray'}}>
                            <span style={{marginLeft:'20px'}}>Telephone : {owner.phone}</span>
                            <span style={{marginLeft:'20px'}}>Email : {owner.email}</span>
                        </div>
                    </div>
                  });
                }
              }
          });
        }
    },[AppState.settings.lang])

    const UsersOptions=(users_)=>{
      let us = []
      users_.map((user)=>{
       us.push({value:user.email, label:
         <div>
             <h4 style={{margin:'0px'}}>{user.labelname}</h4>
             <div style={{marginBottom:'10px',color:'gray'}}>
                 {(!!user.phone) && <span style={{marginLeft:'20px'}}>Telephone : {user.phone}</span>}
                 <span style={{marginLeft:'20px'}}>Email : {user.email}</span>
             </div>
         </div>
       });
       if(user.email === deliver.email)
         setSelectedUser(user);
      });
      setUSers([...us]);
   }

    useEffect(()=>{
      if(!UserState.is_staff && !UserState.is_deliver)
          navigator('/');
      if(!(id==='add' || id===undefined || id===null))
      {
      fetchData.GetData('deliver/'+id+'/').then((result)=>{
          if(result.result)
          {
            const owner = result.deliver.owner;
            setDeliver({...result.deliver});
            if(result.deliver.owned)
            {
                UsersOptions([owner]);
                setSelectedUser({value:owner.email,tag:owner, label:
                <div>
                    <h4 style={{margin:'0px'}}>{owner.labelname}</h4>
                    <div style={{marginBottom:'10px',color:'gray'}}>
                        <span style={{marginLeft:'20px'}}>Telephone : {owner.phone}</span>
                        <span style={{marginLeft:'20px'}}>Email : {owner.email}</span>
                    </div>
                </div>
              });
            }
          }
      });
    }
      
    },[])


    useEffect(()=>{
        fetchData.PostData({page:1},'user/users/').then((result)=>{
          if(result.result)
              UsersOptions(result.users)
        })
    },[])

    const customStyles ={
      control: (base) => ({
        ...base,
        fontSize: 'small',    
      }),
      option: (base) => ({
        ...base,
        fontSize: 'small',    
      }),
      singleValue: (base) => ({
        ...base,
        fontSize: 'small',     
      }),
      placeholder: (base) => ({
        ...base,
        fontSize: 'small',   
      }),
    };

  return (
    <div className='partner' style={{paddingBottom:'30px',paddingBottom:'80px'}}>
      <div className='partner-div'>
        <label className='partner-label'>{t('authentication.nom')}</label>
        <input value={deliver.title} onChange={e=>{setDeliver({...deliver,title:e.target.value});}} className='partner-input' placeholder={t('authentication.nom')} type='text' />
      </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('authentication.telephone')}</label>
        <input value={deliver.phone} onChange={e=>{setDeliver({...deliver,phone:e.target.value});}} className='partner-input' pattern="+269-[0-9]{3}-[0-9]{2}-[0-9]{2}" type='tel' placeholder={t('authentication.telephone')} />
      </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('livreur.admin')}</label>
          <Select styles={customStyles} isDisabled={deliver.owned} value={selectUser} onChange={(value,action)=>{setDeliver({...deliver,email:value.value});}} className='partner-input' options={users} />
        </div>
        { /*
      <div className='partner-div' style={{width:'100%'}}>
        <label className='partner-label'>Prix moyen :</label>
        <input  style={{width:'50%',marginRight:'0px'}} value={deliver.price} onChange={e=>{setDeliver({...deliver,price:e.target.value});}} className='partner-input' type='number' placeholder='0.00' />
        /<select style={{width:'10%',margin:'0px',height:'30px',textAlign:'center'}}>
            <option>m²</option>
            <option>Kg</option>
        </select>
      </div>*/
        }
      <div className='partner-div'>
        <label className='partner-label'>{t('produit.description')}</label>
        <BrowserView className='partner-input' style={{width:'69%'}}>
            <textarea value={deliver.description} onChange={e=>{setDeliver({...deliver,description:e.target.value});}} style={{height:'80px',borderRadius:'5px',padding:'10px',width:'100%',textAlign:'center'}}  placeholder={t('produit.description')} />
        </BrowserView>
        <MobileView className='partner-input' style={{width:'85%',margin:'auto'}}>
            <textarea value={deliver.description} onChange={e=>{setDeliver({...deliver,description:e.target.value});}} style={{height:'80px',margin:'auto',borderRadius:'5px',padding:'10px',width:'100%'}}  placeholder={t('produit.description')} />
        </MobileView>
      </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('livreur.logo')}</label>
        {Logo()}
      </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('livreur.identite')}</label>
        {Identite()}
      </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('livreur.rib')}</label>
        {Rib()}
      </div>
      <div className='partner-div'>
        <label className='partner-label'>{t('livreur.engagement')}</label>
        <input className='partner-input' style={{border:'none',height:'30px'}} type='button' value={t('livreur.telecharger')}/>
      </div>
      <div className='partner-div'>
          <label className='partner-label'>{t('livreur.frets')}</label>
          <fieldset className='partner-input' style={{borderRadius:'5px',padding:'10px 0px 10px 0px'}}>
              {
                deliver.frets.map((fret)=>{
                  return <Fret fret={fret} is_new={false}/>
                })
              }
            <Popup trigger={<input type='button' style={{height:'40px',backgroundColor:'gold',borderRadius:'5px',margin:'10px 5px 5px 5px',border:'none',width:'60%'}} value={t('livreur.ajout-fret')} />}> 
                { close=>(<div style={{position:'fixed',top:'0px',left:'0px',height:'100vh',width:'100%',backgroundColor:'rgba(255,255,255,0.7)'}}>
                    <fieldset className='filedset-new-fret' style={{}}>
                      <Fret is_new={true} close={()=>{close()}} setDeliver={setDeliver}/>
                    </fieldset>
                </div>)}
            </Popup>
          </fieldset>
      </div>
      <div className='partner-div'>
        { (deliver.owned || UserState.is_staff) && 
        <>
          <label className='partner-label'>{t('user-info.appareil-confiance')}</label>
          <div style={{margin:'auto'}} className='partner-input'>
            {(deliver.owned || UserState.is_staff) && <DeviceRegistration owned={deliver.owned} partner={'deliver'} partner_id={deliver.id} device={deliver.device} />}
          </div>
        </>}
      </div>
      <div className='partner-div'>
        <label className='partner-label'>Colis :</label>
        <div className='partner-input'>
            <DeliverOrders deliver_id={id} />
        </div>
      </div>
      <div className='partner-div' style={{height:'40px',width:'60%',margin:'auto',textAlign:'center'}}>
        <div style={{margin:'auto',height:'40px',width:'100%'}}>
          <ButtonLoader onSubmit={SaveDeliver} style={{backGroundColor:'lightgreen'}} loading={loading.loading}  text={loading.text}/>
        </div>
      </div>
    </div>
  )
}

export default Deliver
